// This shows each transaction in a given week in a table with the headers
// User,	Type,	Method,	Description,	Date,	Amount
import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";

function PaymentInfoListBox({ open, onClose, weeklySummary, weekKey }) {
  const handleClose = () => onClose(false);
  // if there is no weekKey or that week doesn't exist then the function can't run.
  if (!weekKey || !weeklySummary[weekKey]) {
    return null; // or a loading state
  }
  // The dictionary that contains all the transactions.
  const summary = weeklySummary[weekKey];

  // Format date for display
  const year = weekKey.substring(0, 4);
  const month = weekKey.substring(4, 6);
  const day = weekKey.substring(6, 8);
  const displayDate = `${month}-${day}-${year}`;

  // Compute totals per location per collectedDate
  const totalsByLocationAndDate = {};
  summary.transactions.forEach((tx) => {
    console.log("tx is", tx);
    const key = `${tx.location || "No Location"}|${
      tx.collectedDate || "No Date"
    }`;
    if (!totalsByLocationAndDate[key]) totalsByLocationAndDate[key] = 0;
    totalsByLocationAndDate[key] += tx.amount;
  });

  return (
    <Dialog fullWidth={true} onClose={handleClose} open={open}>
      <DialogTitle>Payment Details for Week Ending {displayDate}</DialogTitle>
      <DialogContent>
        {/* Totals per location / collected date */}
        <h4>Totals by Location & Collected Date</h4>
        <table
          border="1"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "1rem",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th>Location</th>
              <th>Collected On</th>
              <th>Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(totalsByLocationAndDate).map(([key, total]) => {
              const [location, collectedDate] = key.split("|");
              return (
                <tr key={key}>
                  <td>{location}</td>
                  <td>{collectedDate}</td>
                  <td>{total.toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th>User</th>
              <th>Type</th>
              <th>Method</th>
              <th>Description</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {summary.transactions.map((tx, idx) => (
              <tr key={idx}>
                <td>{tx.name}</td>
                <td>{tx.type}</td>
                <td>{tx.method}</td>
                <td>{tx.description}</td>
                <td>{tx.date}</td>
                <td>{tx.amount.toFixed(2)}</td>
                <td>{tx.location}</td>
              </tr>
            ))}
            {/* Totals row */}
            <tr style={{ backgroundColor: "#ffe0b2", fontWeight: "bold" }}>
              <td colSpan={6}>Totals</td>
              <td>
                {(
                  summary.ETransfer +
                  summary.Cash +
                  summary.F2PMCredits +
                  summary.Refunds +
                  summary.Mileage +
                  summary.Packaging +
                  summary.Misc +
                  summary.CreditCard
                ).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PaymentInfoListBox.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  weeklySummary: PropTypes.object.isRequired,
  weekKey: PropTypes.string.isRequired,
};

export default function PaymentInfoListDialog({ weeklySummary, weekKey }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button color="primary" onClick={handleClickOpen}>
        LIST
      </Button>
      <PaymentInfoListBox
        open={open}
        onClose={handleClose}
        weeklySummary={weeklySummary}
        weekKey={weekKey}
      />
    </div>
  );
}

PaymentInfoListDialog.propTypes = {
  weeklySummary: PropTypes.object.isRequired,
  weekKey: PropTypes.string.isRequired,
};
